import React, { Component } from 'react';
import { CSVLink } from 'react-csv';
import ProductFulfillmentListAuditContainer from 'containers/ProductFulfillmentAuditContainer';
import { listOfValidOptimizationDates, getNextMonthFirstDay } from '@tpco/tpco-saturn-logic';
import { Spinner } from '@tpco/thomas-blueprint-react/dist/es/Components';
import Table from 'views/components/Table/TableComponent';
import memoize from 'memoize-one';
import { Formik, Form } from 'formik';
import { StackedSelect, BooleanCheckbox } from '@tpco/blueprint-react';
import { SortOptions } from 'models/interfaces/Table';
import ProductFulfillmentAuditCacheContainer from 'containers/ProductFulfillmentAuditCacheContainer';
import {
  makeProductAduitHeadings,
  buildRenderDataFromAuditProps,
  buildRenderDataFromAuditExportProps
} from 'views/components/ProductFulfillments/ProductFulfillmentAuditConfig';
interface IState {
  startDate: string;
  getAll: number;
  showResults: boolean;
  isLoading: boolean;
  export: any[];
}
class ProductFulfillmentListAuditPage extends Component<any, IState> {
  constructor(props: any) {
    super(props);
    const nextMonth = getNextMonthFirstDay()
      .format('MM/DD/YYYY')
      .toString();
    this.state = {
      startDate: nextMonth,
      getAll: 0,
      showResults: true,
      isLoading: false,
      export: []
    };
    console.log(this.state.startDate);
  }

  getAllChange = (ga: any) => {
    console.log('getAllchange', ga);
    this.setState({
      getAll: ga.value ? 1 : 0
    });
  };

  newDateChange = (nd: any) => {
    console.log('newDateChangee', nd);
    this.setState({
      startDate: nd.value
    });
  };

  onSubmit;
  componentDidMount() {
    console.log('mounted audit');
  }
  render() {
    return (
      <section>
        <div className="flex-row flex-wrap">
          <h1 className="page-title">Next Publish Campaigns</h1>
          <div className="audit_form-container">
            <Formik
              initialValues={{ newDate: this.state.startDate, newGetAll: false }}
              onSubmit={values => console.log('Submitting P3CampaignEdit: ', values)}
              enableReinitialize={false}
            >
              {({ handleSubmit, values }) => (
                <Form className="audit-campaign__container audit-form">
                  <StackedSelect
                    className="audit-form_object"
                    htmlId="audit-campaign-date"
                    fieldName="newDate"
                    labelText=""
                    onChange={this.newDateChange}
                    options={listOfValidOptimizationDates(this.state.startDate, true)}
                  />
                  <BooleanCheckbox
                    htmlId="select-all-campaigns-audit"
                    fieldName="newGetAll"
                    labelText="All Campaigns"
                    className="audit-form_object"
                    onChange={this.getAllChange}
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>

        {this.state.showResults && (
          <ProductFulfillmentAuditCacheContainer>
            {({ fulfillmentAuditPageCache, updateCache, loading }) => {
              const { sortOptions, activeSort } = fulfillmentAuditPageCache;

              return (
                <ProductFulfillmentListAuditContainer
                  startDate={this.state.startDate}
                  getAll={this.state.getAll}
                  activeSort={activeSort}
                >
                  {({ productFulfillments, loading }) => {
                    // this.setState({
                    //   export: productFulfillments
                    // });

                    let fulfillmentDisplayRows: any = [];
                    const all = this.state.getAll === 1 ? '-all' : '';
                    const filename = `${this.state.startDate}${all}-audit.csv`;
                    const memoizedRenderData = memoize(buildRenderDataFromAuditProps);
                    const memoizedRenderExportData = memoize(buildRenderDataFromAuditExportProps);
                    const [fullfilemtnMap, fulfilmentsRows] = memoizedRenderData(
                      productFulfillments
                    );

                    const [fullfilemtnExportMap, fulfilmentsExportRows] = memoizedRenderExportData(
                      productFulfillments
                    );
                    fulfillmentDisplayRows = fulfilmentsRows;

                    return (
                      <div>
                        <section className="card audit-export-card">
                          <CSVLink
                            data={fulfilmentsExportRows}
                            filename={filename}
                            className="btn btn-primary header-title-btn audit-button-export"
                            target="_blank"
                          >
                            export
                          </CSVLink>
                        </section>
                        <section className="card">
                          {loading ? (
                            <Spinner color="secondary" variant="horizontal" />
                          ) : (
                            <div className="thomas-advertisers__item-body">
                              <Table
                                headings={makeProductAduitHeadings(sortOptions)}
                                data={fulfillmentDisplayRows}
                                onSort={(sortKey: string, sortDirection: string) => {
                                  const newSortOptions: SortOptions = Object.assign(
                                    {},
                                    sortOptions
                                  );
                                  Object.keys(newSortOptions).forEach(
                                    (key: string): void => {
                                      if (key === sortKey) {
                                        newSortOptions[key] = sortDirection;
                                      } else {
                                        newSortOptions[key] = 'DESC';
                                      }
                                    }
                                  );
                                  const data = {
                                    fulfillmentAuditPageCache: {
                                      sortOptions: newSortOptions,
                                      activeSort: {
                                        sortKey,
                                        sortDirection
                                      }
                                    }
                                  };
                                  updateCache(data);
                                }}
                              />
                            </div>
                          )}
                        </section>
                      </div>
                    );
                  }}
                </ProductFulfillmentListAuditContainer>
              );
            }}
          </ProductFulfillmentAuditCacheContainer>
        )}
      </section>
    );
  }
}

export default ProductFulfillmentListAuditPage;
